import React from "react";


const Form = (props) => {

  return (
    <div className="py-10 px-2">
      <div className="elfsight-app-74fcae24-96d8-48ae-b245-919da85278fe"></div>
    </div >
  );
};

export default Form;


// variable del formulario:
// tname=""
// tlname=""
// temail=""
// tphone=""
// taddress=""
// ttypeservice=""
// tbestway=""
// tcheckphone=""
// tcheckcorreo=""
// tmessage=""
// tbutton=""
// isenglish="true"
